import { makeStyles } from '@mui/styles';
const darkGray = '#263238';
const lightGray = '#3f505a';
const ligherGray = '#cfd8dc';
const green = '#508b46';
export const useStyles = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #A1AAE380',
      borderRadius: 10,
      background: '#A1AAE312',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
    },
    avatarDefault: {
      borderRadius: 33,
      width: 62,
      height: 62,
      border: `1px solid #ccd1f0`,
      display: 'inline-block',
      textAlign: 'center',
      lineHeight: '80px',

    },
    profileImage: {
      borderRadius: 33,
      display: 'inline-block',
      width: 65,
      height: 65,
      border: `1px solid ${theme.palette.gray[1]}`,
    },
    content: {
      paddingBottom: theme.spacing(0.5),
    },
    // Key Header
    titlePart: {
      marginInlineEnd: 'auto',
      paddingInlineStart: 15,
    },
    titleText: {
      fontSize: 14,
      color: theme.palette.grey[7],
      fontWeight: 'bold',
      marginTop: theme.spacing(0.5),
    },
    subtitleText: {
      fontSize: 13,
      color: '#A4A4A4',
      fontWeight: 'normal',
      marginTop: theme.spacing(0.5),
    },
    subestTitleText: {
      fontSize: 13,
      color: theme.palette.grey[6],
      fontWeight: 200,
      marginTop: theme.spacing(0),
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: `10px`,
      paddingInlineEnd: '10px',
      marginInlineEnd: '6px',
      fontSize: '12px',
      margin: '2px 0',
      borderRadius: 8,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      backgroundColor: '#ffffff',
      fontSize: '12px',
      '@media(max-width: 550px)': {
        '&:nth-child(1)': {
          width: '25.33%',
        },
        '&:nth-child(2)': {
          width: '28.33%',
        },
        '&:nth-child(3)': {
          width: '40%',
        }
      }
    },
    balanceTitle: {
      marginTop: theme.spacing(2),
      fontSize: 12,
      color: darkGray,
      fontWeight: 'bold',
    },
    balanceMoney: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'normal',
      '& span': {
        fontSize: 14,
        color: lightGray,
        marginInlineStart: theme.spacing(0.5),
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(-1.5),
      marginTop: theme.spacing(-0.5),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      color: '#7d8f9b',
      padding: theme.spacing(1),
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    propertyContainer: {
      marginTop: theme.spacing(3),
    },
    property: {
      fontSize: 14,
      color: lightGray,
      fontWeight: '400',
    },
    propertyIcon: {
      fontSize: 25,
      color: ligherGray,
      marginInlineEnd: theme.spacing(1),
      '&.active': {
        color: green,
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
      paddingTop: '5px',
      lineHeight: '34px',
      '@media(max-width: 550px)': {
        fontSize: 12,
        margin: '0',
        marginInlineStart: 'auto',
        lineHeight: '40px',
        textAlign: 'right',
        width: '40px',
        display: 'block',
        paddingRight: '5px',

      },

      '& .MuiIconButton-root': {
        border: '2px solid #303d8f',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        padding: '0',
        marginRight: 3,
        '& svg': {
          fill: '#303d8f',
          transform: 'scale(0.8)'
        }
      },
      '& .MuiButton-text': {
        fontSize: 13,
        color: '#3a49a3',
        fontWeight: 'bold'
      }
    },
    otherActionsMenu: {
      border: '1px solid #d8d1d1',
      '& .MuiButtonBase-root.Mui-disabled': {
        pointerEvents: 'auto !important',
      },
    },
    otherActionsMenuItem: {
      padding: theme.spacing(1.5),
      color: darkGray,
      minWidth: 160,
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
    sheba: {
      marginTop: theme.spacing(1),
    },
    shebaNumber: {
      fontSize: 14,
      color: '#546e7a',
      fontWeight: 'normal',
      fontFamily: 'Vazir',
      overflowWrap: 'break-word',
    },
    copyIcon: {
      fontSize: 15,
    },
    copyIconButton: {
      width: 15,
      height: 15,
      marginInlineStart: theme.spacing(1),
      marginTop: -2,
    },
  };
});